import request from '@/axios'

export function notificationList (customer_id, limit, page = 1, sorting_obj = {}, table_name, payload) {
  let url = ''
  if (Object.entries(sorting_obj).length > 0) {
    url = `/notification/notification_list/${customer_id}/${limit}?attribute=${sorting_obj.attribute}&direction=${sorting_obj.direction}&field_type=${sorting_obj.field_type}&table_name=${table_name}&page=${page}`
  } else {
    url = `/notification/notification_list/${customer_id}/${limit}?page=${page}`
  }
  return request({
    url,
    method: 'POST',
    data:payload
  })
}

export function notificationRead (query) {
  return request({
    url: '/notification/notification_read',
    method: 'POST',
    data: query
  })
}

export function notificationDelete (query) {
  return request({
    url: '/notification/notification_delete',
    method: 'POST',
    data: query
  })
}


export function notification_redirection (customer_id, notification_id) {
  return request({
    url: `/notification/notification_redirection/${customer_id}/${notification_id}`,
    method: 'GET'
  })
}


export function homework_redirection (platform_customer_id, assignment_id) {
  return request({
    url: `/assignment-builder/get/${platform_customer_id}/${assignment_id}`,
    method: 'GET'
  })
}

export function certificate_redirection (customer_id, certificate_id) {
  return request({
    url: `/certificate/show/${customer_id}/${certificate_id}`,
    method: 'GET'
  })
}